import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { clientApi } from "./api";

const ClientAuthCtx = createContext({ user: null, loading: true, login: () => {}, logout: () => {}, refresh: () => {} });

export function ClientAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await clientApi.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      // OAuth callback — skip /me until exchange completes in the callback page
      setLoading(false);
      return;
    }
    check();
  }, [check]);

  const login = useCallback(async (email, password) => {
    const { data } = await clientApi.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await clientApi.post("/auth/logout"); } catch (e) { /* noop */ }
    setUser(null);
    if (typeof window !== "undefined") window.location.href = "/cliente/login";
  }, []);

  return (
    <ClientAuthCtx.Provider value={{ user, loading, login, logout, refresh: check, setUser }}>
      {children}
    </ClientAuthCtx.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthCtx);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Erro desconhecido. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
